import { NgIf } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { InstitutionModalComponent } from '@backoffice/institution/institution-modal.component';
import { InstitutionService } from '@backoffice/institution/institution.service';
import { getModalWidth } from '@constants/constants';
import { Account } from '@core/auth/account.model';
import { AccountService } from '@core/auth/account.service';
import { PersonService } from '@core/user/person.service';
import { EventManager } from '@core/util/event-manager.service';
import { StorageService } from '@flowinn/components/filter/storage.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IInstitutionClient, InstitutionClient } from '@model/client/institution-client.model';
import { IPersonInstitution } from '@model/client/person-institution.model';

import { IPersonYoung } from '@model/client/person-young.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { Subscription } from 'rxjs';

@Component({
  selector: 'jhi-institution',
  templateUrl: './institution.component.html',
  imports: [TableModule, FontAwesomeModule, NgIf],
  standalone: true,
})
export class InstitutionComponent implements AfterViewInit {
  account?: Account | null;
  currentLanguage?: string;
  personInstitutions: IPersonInstitution[] = [];
  person?: IPersonYoung;
  institution?: IInstitutionClient;
  eventSubscriber?: Subscription;

  constructor(
    private accountService: AccountService,
    private storageService: StorageService,
    protected personService: PersonService,
    protected eventManager: EventManager,
    protected dialogService: DialogService,
    protected modalService: NgbModal,
    protected institutionService: InstitutionService,
    private translateService: TranslateService
  ) {}

  trackId(index: number, item: any): void {
    return item.id;
  }

  ngAfterViewInit(): void {
    this.accountService.identity().subscribe(account => {
      this.account = account;
      if (this.account != null) {
        const accountId = this.account.id;
        this.eventSubscriber = this.eventManager.subscribe(
          'flw-institution',
          () => (this.institution = this.storageService.getStorageInstitution(accountId))
        );
        this.person = this.accountService.getPerson();
        this.personInstitutions = this.accountService.getInstitutions();
        this.institution = this.storageService.getStorageInstitution(accountId);
      }
    });
    this.currentLanguage = this.translateService.currentLang;
  }

  previousState(): void {
    window.history.back();
  }

  openInstitutionModal(institutionId?: number, designation?: string): void {
    if (institutionId) {
      this.dialogService.open(InstitutionModalComponent, {
        data: {
          institutionId,
        },
        header: designation ?? 'Instituição',
        width: getModalWidth(),
        maximizable: true,
      });
    }
  }

  selectInstitution(institutionClient?: InstitutionClient): void {
    if (this.account != null) {
      if (institutionClient) {
        this.storageService.setStorageInstitution(this.account.id, institutionClient);
      } else {
        this.storageService.clearStorageInstitution(this.account.id);
      }
    }
  }
}
